// Used in assignment-info-dialog.component.html and tiles.component.html

// Angular
import { Component, Input, OnInit } from "@angular/core";

@Component({
    selector: "ready-check-directions",
    templateUrl: "./ready-check-directions.component.html",
    styleUrls: [
        "./ready-check-directions.component.scss",
        "../../../styles/shared-styles.scss",
    ],
    standalone: false
})
export class ReadyCheckDirectionsComponent implements OnInit {
    @Input() directions: any;
    @Input() fontSize: string;

    constructor() {}

    ngOnInit(): void {}
}
